import {
    FaCopy,
    FaCreditCard,
    FaMapMarkerAlt,
    FaMountain,
    FaUniversity,
    FaWallet
} from "react-icons/fa";

import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import API_BASE_URL from "../config";
import "./css/Payment.css";

function Payment() {
    const navigate = useNavigate();
    const location = useLocation();

    // Menangkap data yang dikirim dari navigasi halaman sebelumnya
    const { villa, bookingData } = location.state || {};

    const [method, setMethod] = useState("");
    const [subMethod, setSubMethod] = useState("");
    const [showBankPopup, setShowBankPopup] = useState(false);
    const [showEwalletPopup, setShowEwalletPopup] = useState(false);
    const [paymentType, setPaymentType] = useState("");
    const [agree, setAgree] = useState(false);

    // Debugging di Console Browser untuk memeriksa payload data yang masuk
    useEffect(() => {
        console.log("=== DEBUG DATA PAYMENT ===");
        console.log("Data Villa dari State:", villa);
        console.log("Data Booking dari State:", bookingData);
    }, [villa, bookingData]);

    const totalPrice = bookingData?.total_price || 2000000;
    const dpPrice = totalPrice * 0.5;

    // 🛠️ MULTI-FALLBACK AUTO IMAGE DETECTOR
    const getVillaImage = () => {
        // 1. Cari di dalam object villa (jika dikirim terpisah)
        if (villa?.img) return villa.img;
        if (villa?.image) return villa.image;
        if (villa?.image_url) return villa.image_url;
        if (villa?.room_image) return villa.room_image;
        if (villa?.images && villa.images.length > 0) return villa.images[0];

        // 2. Cari di dalam object bookingData (jika digabung oleh halaman Booking)
        if (bookingData?.room_image) return bookingData.room_image;
        if (bookingData?.room_img) return bookingData.room_img;
        if (bookingData?.villa_img) return bookingData.villa_img;
        if (bookingData?.villa_image) return bookingData.villa_image;
        if (bookingData?.image) return bookingData.image;
        if (bookingData?.img) return bookingData.img;
        if (bookingData?.image_url) return bookingData.image_url;

        // 3. Cadangan terakhir jika data benar-benar kosong dari halaman sebelah
        return "https://images.unsplash.com/photo-1613977257363-707ba9348227?q=80&w=600";
    };

    const copyText = (text) => {
        navigator.clipboard.writeText(text);
        alert("Berhasil disalin!");
    };

    const handleConfirmPayment = async () => {
        if (!method) return alert("Pilih metode!");
        if (!paymentType) return alert("Pilih tipe pembayaran!");
        if ((method === "bank" || method === "ewallet") && !subMethod)
            return alert("Pilih detail!");
        if (!agree) return alert("Harus setuju syarat!");

        const finalBookingData = {
            ...bookingData,
            total_price: paymentType === "dp" ? dpPrice : totalPrice,
            payment_method: subMethod || method,
            payment_type: paymentType,
            status: "Pending"
        };

        try {
            const response = await fetch(`${API_BASE_URL}/api/bookings`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(finalBookingData),
            });

            const result = await response.json();

            if (response.ok) {
                navigate("/success", { state: { bookingData: finalBookingData } });
            } else {
                alert("Gagal menyimpan booking: " + result.error);
            }
        } catch (error) {
            console.error("Error connecting to BE:", error);
            alert("Terjadi kesalahan koneksi ke server Backend.");
        }
    };

    return (
        <div className="payment-page">
            {/* NAVBAR */}
            <nav className="navbar">
                <div className="logo">
                    <div className="logo-icon"><FaMountain /></div>
                    <div className="logo-text">
                        <h3>Permata Wisata</h3>
                        <span>Jogja Tourism</span>
                    </div>
                </div>
                <div className="nav-menu">
                    <Link to="/">Home</Link>
                    <Link to="/villas">Villas</Link>
                    <a href="https://wa.me/081216687367" target="_blank" rel="noopener noreferrer" className="contact-btn">
                        Hubungi Kami
                    </a>
                </div>
            </nav>

            {/* HEADER */}
            <div className="payment-header">
                <Link to="/booking" className="back-link">&larr; Back to Booking</Link>
                <h1>Payment</h1>
            </div>

            {/* CONTAINER */}
            <div className="payment-container">
                {/* LEFT SIDE */}
                <div className="payment-left">
                    <div className="payment-card">
                        <h3>Select Payment Method</h3>
                        <div className={`method ${method === "bank" ? "active" : ""}`} onClick={() => { setMethod("bank"); setShowBankPopup(true); }}>
                            <FaUniversity />
                            <div><b>Bank Transfer</b><p>BCA, Mandiri, BNI</p></div>
                        </div>
                        <div className={`method ${method === "ewallet" ? "active" : ""}`} onClick={() => { setMethod("ewallet"); setShowEwalletPopup(true); }}>
                            <FaWallet />
                            <div><b>E-Wallet</b><p>GoPay, OVO, Dana</p></div>
                        </div>
                        <div className={`method ${method === "cc" ? "active" : ""}`} onClick={() => setMethod("cc")}>
                            <FaCreditCard />
                            <div><b>Credit Card</b><p>Visa, Mastercard</p></div>
                        </div>
                        <div className={`method ${method === "qris" ? "active" : ""}`} onClick={() => setMethod("qris")}>
                            <FaWallet />
                            <div><b>QRIS</b><p>Scan QR untuk pembayaran instan</p></div>
                        </div>
                    </div>

                    <div className="payment-card">
                        <h3>Pilih Tipe Pembayaran</h3>
                        <div className={`method ${paymentType === "dp" ? "active" : ""}`} onClick={() => setPaymentType("dp")}>
                            <div>
                                <b>DP 50%</b>
                                <p>Rp {dpPrice.toLocaleString()}</p>
                                <p>Batas pelunasan 20 Mei 2026</p>
                            </div>
                        </div>
                        <div className={`method ${paymentType === "full" ? "active" : ""}`} onClick={() => setPaymentType("full")}>
                            <div><b>Full Payment</b><p>Rp {totalPrice.toLocaleString()}</p></div>
                        </div>
                    </div>

                    {/* POPUPS */}
                    {showBankPopup && (
                        <div className="popup-overlay">
                            <div className="popup-box">
                                <h4>Pilih Bank</h4>
                                <div className="popup-options">
                                    {["bca", "mandiri", "bni"].map(item => (
                                        <div key={item} className={`popup-item ${subMethod === item ? "active" : ""}`} onClick={() => { setSubMethod(item); setShowBankPopup(false); }}>
                                            {item.toUpperCase()}
                                        </div>
                                    ))}
                                </div>
                                <button onClick={() => setShowBankPopup(false)}>Close</button>
                            </div>
                        </div>
                    )}

                    {showEwalletPopup && (
                        <div className="popup-overlay">
                            <div className="popup-box">
                                <h4>Pilih E-Wallet</h4>
                                <div className="popup-options">
                                    {["gopay", "ovo", "dana"].map(item => (
                                        <div key={item} className={`popup-item ${subMethod === item ? "active" : ""}`} onClick={() => { setSubMethod(item); setShowEwalletPopup(false); }}>
                                            {item.toUpperCase()}
                                        </div>
                                    ))}
                                </div>
                                <button onClick={() => setShowEwalletPopup(false)}>Close</button>
                            </div>
                        </div>
                    )}

                    {/* INSTRUCTIONS */}
                    <div className="payment-card">
                        <h3>Payment Instructions</h3>
                        {method === "bank" && subMethod && (
                            <div className="bank-box">
                                <div className="bank-row"><span>Bank</span><b>{subMethod.toUpperCase()}</b></div>
                                <div className="bank-row">
                                    <span>No Rekening</span>
                                    <b>
                                        {subMethod === "bca" && "1234567890"}
                                        {subMethod === "mandiri" && "9876543210"}
                                        {subMethod === "bni" && "1122334455"}
                                        <FaCopy className="copy-icon" onClick={() => copyText(subMethod === "bca" ? "1234567890" : subMethod === "mandiri" ? "9876543210" : "1122334455")} />
                                    </b>
                                </div>
                                <div className="bank-row"><span>Atas Nama</span><b>PT Permata Wisata Indonesia</b></div>
                            </div>
                        )}

                        {method === "ewallet" && subMethod && (
                            <div className="bank-box">
                                <div className="bank-row"><span>E-Wallet</span><b>{subMethod.toUpperCase()}</b></div>
                                <div className="bank-row">
                                    <span>Nomor</span>
                                    <b>081234567890 <FaCopy className="copy-icon" onClick={() => copyText("081234567890")} /></b>
                                </div>
                                <div className="bank-row"><span>Atas Nama</span><b>Permata Wisata</b></div>
                            </div>
                        )}

                        {method === "qris" && (
                            <div className="qris-box">
                                <h4>QRIS Payment</h4>
                                <img src="https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=PermataWisataPayment" alt="QRIS" />
                                <p>Scan QR untuk pembayaran</p>
                            </div>
                        )}

                        <h4>How to Pay:</h4>
                        <ul className="steps">
                            <li>Transfer sesuai nominal</li>
                            <li>Simpan bukti pembayaran</li>
                            <li>Klik "Confirm Payment"</li>
                        </ul>

                        <div style={{ marginTop: "10px" }}>
                            <input type="checkbox" checked={agree} onChange={() => setAgree(!agree)} /> Saya setuju dengan syarat & ketentuan
                        </div>
                        <button className="confirm-btn" onClick={handleConfirmPayment}>Confirm Payment</button>
                    </div>
                </div>

                {/* RIGHT SIDE (SUMMARY) */}
                <div className="payment-right">
                    <h3>Order Summary</h3>
                    <div className="summary-card">
                        {/* 🌟 AKTIVASI LINK GAMBAR OTOMATIS DISINI 🌟 */}
                        <img
                            src={getVillaImage()}
                            alt={bookingData?.villa_name || "Villa Akomodasi"}
                            className="summary-img"
                            style={{ width: "100%", height: "200px", objectFit: "cover", borderRadius: "8px" }}
                            onError={(e) => { 
                                // Jika URL gambar dari database bermasalah/broken link, balikkan ke gambar ini
                                e.target.src = "https://images.unsplash.com/photo-1613977257363-707ba9348227?q=80&w=600"; 
                            }}
                        />
                        <h4>{bookingData?.villa_name || "Tropical Pool Villa Jogja"}</h4>
                        <p className="location"><FaMapMarkerAlt /> Sleman, Yogyakarta</p>

                        <div className="summary-row"><span>Check-in</span><span>{bookingData?.check_in || "-"}</span></div>
                        <div className="summary-row"><span>Check-out</span><span>{bookingData?.check_out || "-"}</span></div>
                        <div className="summary-row"><span>Guests</span><span>{bookingData?.guests || "0"} guests</span></div>
                        <hr />
                        <div className="summary-row"><span>Guest Name</span><span>{bookingData?.full_name || "-"}</span></div>
                        <div className="summary-row"><span>Email</span><span>{bookingData?.email || "-"}</span></div>
                        <div className="summary-row"><span>WhatsApp</span><span>{bookingData?.whatsapp || "-"}</span></div>
                        <hr />
                        <div className="summary-row total">
                            <span>Total Payment</span>
                            <span className="price">Rp {(paymentType === "dp" ? dpPrice : totalPrice).toLocaleString()}</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* FOOTER */}
            <footer className="footer-container">
                <div className="footer-content">
                    <div className="footer-section footer-left">
                        <h2>Permata Wisata</h2>
                        <p>Penyedia layanan akomodasi villa terbaik di Yogyakarta.</p>
                    </div>
                    <div className="footer-section footer-center">
                        <h3>Hubungi Kami</h3>
                        <p>📞 +62 812-1668-7367</p>
                    </div>
                </div>
                <hr className="footer-divider" />
                <p className="footer-bottom">&copy; {new Date().getFullYear()} Permata Wisata. All Rights Reserved.</p>
            </footer>
        </div>
    );
}

export default Payment;